module.exports = __webpack_public_path__ + "img/line-blue-long-swoop-top.0f1af749.png";